import { useMemo } from 'react';

import { FeatureFlags } from '~/stores/use-feature-flags/feature-flags.types';
import { useFeatureFlags } from '~/stores/use-feature-flags/useFeatureFlags';
import { useFilterOptionSearch } from '~/views/screener/use-filter-option-search/useFilterOptionSearch';
import { useScreenerStore } from '~/views/screener/use-screener-store/useScreenerStore';

export const themeExposureFilterKey = 'theme_exposure';

export const useThemeSearch = () => {
  const { filterGroups } = useScreenerStore();
  const { flags } = useFeatureFlags();
  const hasSearchByThemeEnabled = !!flags[FeatureFlags.ENABLE_SEARCH_BY_THEME];

  const knowledgeGraphFiltersConfigOptions =
    filterGroups['Knowledge Graph Filters']?.allFilters.find(
      filter => filter.key === themeExposureFilterKey
    )?.config.options ?? [];

  const { data, handleTextChange } = useFilterOptionSearch(
    themeExposureFilterKey,
    knowledgeGraphFiltersConfigOptions
  );

  const themeSearchResults = useMemo(() => {
    return data.map(filterOption => ({
      name: filterOption.name,
      id: filterOption.value.id as string,
      isTheme: true,
    }));
  }, [data]);

  return { themeSearchResults, handleTextChange, hasSearchByThemeEnabled };
};
